import { render, staticRenderFns } from "./VerticalNavMenuNexos.vue?vue&type=template&id=36e4ff79"
import script from "./VerticalNavMenuNexos.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuNexos.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuNexos.vue?vue&type=style&index=0&id=36e4ff79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports